// extracted by mini-css-extract-plugin
export var label = "toggleSwitch-module--label--826ff";
export var leftLabel = "toggleSwitch-module--leftLabel--f0189";
export var rightLabel = "toggleSwitch-module--rightLabel--f7019";
export var toggle = "toggleSwitch-module--toggle--b4bae";